module.exports = __webpack_public_path__ + "img/boa.f94e2cfa.svg";